import { apiAssetUrl, apiGet, apiPost } from "../../shared/api";

export type StatoPratica = "manca_nostro" | "aperta" | "rimborsata" | "respinta" | "chiusa";
export type TipoPratica = "danno" | "smarrimento" | "firma" | "servizio" | "altro";

/** Una pratica di rimborso con Bracchi, ricalcolata ogni ora dalle mail. */
export type Pratica = {
  id: number;
  ldv: string;
  tipo: TipoPratica;
  stato: StatoPratica;
  aperta_il: string;
  ultimo_il: string;
  ultimo_da_noi: boolean;
  ultimo_testo: string;
  /** La domanda di Bracchi, solo quando tocca a noi. */
  cosa_manca: string;
  /** La frase di Bracchi che ha deciso l'esito. */
  esito: string;
  /** Stringa: arriva da Decimal. */
  importo_rimborso: string | null;
  messaggi: number;
  cliente: string;
  ordine: { id: number; reference: string; canale: string } | null;
  abbinamento: "ldv" | "riferimento" | "nome" | null;
  bozza: Bozza | null;
  /** Vero se l'ha scritto un operatore (BRT, Poste), falso se viene dalle mail. */
  manuale: boolean;
  corriere: string;
  nota: string;
};

export type TipoBozza = "format" | "risposta" | "sollecito";
export type StatoBozza = "bozza" | "in_invio" | "inviata" | "errore";

/** La mail per Bracchi preparata da OM: la manda Davide col tasto Invia. */
export type Bozza = {
  id: number;
  tipo: TipoBozza;
  stato: StatoBozza;
  destinatario: string;
  oggetto: string;
  testo: string;
  /** Nome del format allegato, se c'e'. */
  allegato: string | null;
  errore: string | null;
  inviata_il: string | null;
};

export type CorriereManuale = "brt" | "poste";

export type NuovoReclamo = {
  ordine: string;
  corriere: CorriereManuale;
  tipo: TipoPratica;
  stato: StatoPratica;
  /** Solo se rimborsata. */
  importo_rimborso?: string;
};

export type Reclami = {
  pratiche: Pratica[];
  conteggi: Record<StatoPratica, number>;
  attive: number;
  rimborsato: string;
  aggiornate_il: string | null;
  aggiornamento_in_corso: boolean;
};

const ROTTA = "/api/reclami";

export function fetchReclami(signal?: AbortSignal): Promise<Reclami> {
  return apiGet(ROTTA, signal ? { signal } : undefined);
}

export function creaReclamoManuale(dati: NuovoReclamo): Promise<Pratica> {
  return apiPost(`${ROTTA}/manuali`, dati);
}

export function rileggiReclami(): Promise<{ accodato: boolean }> {
  return apiPost(`${ROTTA}/rileggi`);
}

/** Il segnaposto che il backend rifiuta: va sostituito con la risposta. */
export const SEGNAPOSTO = "[SCRIVI QUI LA RISPOSTA]";

export function inviaBozza(id: number, testo: string): Promise<{ stato: string }> {
  return apiPost(`${ROTTA}/bozze/${id}/invia`, { testo });
}

export function scartaBozza(id: number): Promise<{ stato: string }> {
  return apiPost(`${ROTTA}/bozze/${id}/scarta`);
}

export function urlAllegato(id: number): string {
  return apiAssetUrl(`${ROTTA}/bozze/${id}/allegato`);
}
